import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=7c53fd7a&scoped=true&"
import script from "./activityDetail.vue?vue&type=script&lang=js&"
export * from "./activityDetail.vue?vue&type=script&lang=js&"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=7c53fd7a&scoped=true&lang=less&"
import style1 from "./activityDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53fd7a",
  null
  
)

export default component.exports